import React from 'react';
import type { Definition } from '../../../../../common/types';
import {
	START_CONDITIONS_FIELD_NAME,
	PAUSE_CONDITIONS_FIELD_NAME,
	STOP_CONDITIONS_FIELD_NAME,
} from '../../../../../common/ui/constants.tsx';
import { ConditionView } from './condition';

type Props = {
	conditions: Definition;
};

export const ConditionListView = ({ conditions }: Props) => (
	<>
		<ConditionView selectedConditions={conditions.start} listName={START_CONDITIONS_FIELD_NAME} />

		<ConditionView selectedConditions={conditions.pause} listName={PAUSE_CONDITIONS_FIELD_NAME} />

		<ConditionView selectedConditions={conditions.stop} listName={STOP_CONDITIONS_FIELD_NAME} />
	</>
);
